<template>
  <div class="card">
    <div class="card-body">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h5 class="card-title" v-html="this.$t('BomPriceTable.bomPrice')" />
      </div>
      <table class="table">
        <thead>
          <tr>
            <th class="w-100">
              {{ this.$t('BomPriceTable.multiple') }}
            </th>
            <th class="text-end text-nowrap">
              {{ this.$t('BomPriceTable.totalPrice') }}
            </th>
            <th class="text-center text-nowrap">
              {{ this.$t('BomPriceTable.stockAvailable') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr class="align-middle">
            <td>
              <input
                type="number"
                class="form-control m-0"
                @input="refetchPrices($event.target.value)"
                min="1"
                size="5"
                :value="quantityPrice.quantity"
                :disabled="bomStore.areJobsRunning"
              >
            </td>
            <td class="text-end">
              {{ quantityPrice.totalPrice }}
              <div class="text-muted small text-nowrap">
                {{ quantityPrice.unitPrice }} / {{ $t('BomPriceTable.perPiece') }}
              </div>
            </td>
            <td class="text-center">
              <StockIndicator :availability="quantityPrice.availability" />
            </td>
          </tr>
          <tr v-if="quantityPrice.availability === 'unavailable'">
            <td colspan="4">
              <p class="mb-0" v-html="this.$t('BomPriceTable.unavailableQuantitiesHint')" />
            </td>
          </tr>
          <tr v-for="item in bomStore.previewPrices" :key="item.quantity" class="align-middle">
            <td>{{ item.quantity }}</td>
            <template v-if="item.calculated">
              <td class="text-end ">
                {{ item.totalPrice }}
                <div class="text-muted small text-nowrap">
                  {{ item.unitPrice }} / {{ $t('BomPriceTable.perPiece') }}
                </div>
              </td>
              <td class="text-center">
                <StockIndicator :availability="item.availability" />
              </td>
            </template>
            <template v-else>
              <td class="text-end pt-3">
                <span class="placeholder-wave d-flex flex-column gap-1">
                  <span class="placeholder w-100 rounded-1" />
                  <span class="placeholder w-100 rounded-1 placeholder-thin" />
                </span>
              </td>
              <td class="text-center">
                <span class="placeholder-wave">
                  <span class="placeholder w-50 rounded-1" />
                </span>
              </td>
            </template>
          </tr>
        </tbody>
      </table>
      <div class="cell padding-top-1 padding-left-1 padding-right-1">
        <p class="mb-0" v-html="this.$t('BomPriceTable.validity')" />
        <p class="mt-1 mb-0" v-html="$t('BomPriceTable.priceNotice')" />
      </div>
      <p class="mt-2 mb-0" v-html="$t('BomPriceTable.higherVolumesHint')" />
    </div>
  </div>
</template>

<script>
import messages from 'locales/BomPriceTable';
import { debounce } from 'lodash';
import { closestQuantity } from 'helper/quantities';
import { useBomStore } from 'store/bom';
import StockIndicator from './StockIndicator.vue';

export default {
  name: 'BomPriceTable',
  components: {
    StockIndicator,
  },
  setup() {
    const bomStore = useBomStore();
    return { bomStore };
  },
  computed: {
    quantityPrice() {
      return this.bomStore.quantityPrice;
    },
  },
  methods: {
    refetchPrices: debounce(function (newQtyStr) {
      const newQty = parseInt(newQtyStr, 10);
      if (!newQty) {
        return;
      }

      const quantity = closestQuantity(newQty, this.quantityPrice.quantity, this.bomStore.availablePrices);
      this.bomStore.fetchPrices(quantity);
    }, 1000),
  },
  i18n: { messages },
};
</script>

<style lang="scss" scoped>
  .placeholder-thin {
    font-size: 0.5rem;
    line-height: 0.5rem;
    vertical-align: middle;
  }
</style>
